import React from 'react';
import { XIcon, MessageCircleIcon } from 'lucide-react';
export const StickyBottomBar = ({
  totalPrice,
  selectedScenario,
  addOns,
  addOnPrices,
  formatPrice,
  showVat
}) => {
  const getVatAdjustedPrice = price => {
    return showVat ? price : Math.round(price / 1.25);
  };
  const selectedAddOns = Object.keys(addOns).filter(key => addOns[key]);
  const addOnLabels = {
    wifiThermostats: 'WiFi-termostater',
    energyMonitoring: 'Energiovervågning',
    serviceAgreement: 'Serviceaftale',
    extendedWarranty: 'Udvidet garanti',
    expressDelivery: 'Ekspreslevering'
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-10" data-id="element-222">
      <div className="container mx-auto px-4 py-3" data-id="element-223">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-224">
          <div className="flex flex-wrap items-center gap-2" data-id="element-225">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-226">
              {selectedScenario.name}
            </span>
            {selectedAddOns.map(key => <span key={key} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-227">
                {addOnLabels[key]}
                <button className="ml-1 text-blue-500 hover:text-blue-700" data-id="element-228">
                  <XIcon className="h-3 w-3" data-id="element-229" />
                </button>
              </span>)}
          </div>
          <div className="flex items-center gap-6" data-id="element-230">
            <div className="text-right" data-id="element-231">
              <div className="text-sm text-gray-500" data-id="element-232">
                Netto salgspris ({showVat ? 'inkl.' : 'ekskl.'} moms)
              </div>
              <div className="text-xl font-bold text-gray-900" data-id="element-233">
                {formatPrice(getVatAdjustedPrice(totalPrice))}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-234">
              <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 flex items-center gap-2" data-id="element-235">
                <MessageCircleIcon className="h-4 w-4" data-id="element-236" />
                Stil spørgsmål
              </button>
              <button className="px-4 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-237">
                Accepter tilbud
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};